import { useState } from 'react';

const testimonials = [
  {
    name: '李女士',
    location: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20woman%20in%20her%2030s%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20friendly%20confident%20expression%2C%20clean%20minimalist%20style&width=120&height=120&seq=avatar-xb-01&orientation=squarish',
    rating: 5,
    text: '第一次接触性巴克就被深深吸引。产品的质感超乎想象，设计简约又不失格调，现在已经成了我生活中不可或缺的一部分。每次使用都能感受到品牌对品质的执着。',
    product: '经典系列',
  },
  {
    name: '张先生',
    location: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20man%20in%20his%2030s%2C%20soft%20studio%20lighting%2C%20warm%20cream%20background%2C%20friendly%20confident%20expression%2C%20clean%20modern%20style&width=120&height=120&seq=avatar-xb-02&orientation=squarish',
    rating: 5,
    text: '关注性巴克已经两年了，从最初被品牌理念打动，到现在成为忠实用户。性巴克从来没有让我失望过，每一代产品都在进步，这种持续创新的精神真的很难得。',
    product: '新品系列',
  },
  {
    name: '王女士',
    location: '深圳',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20woman%20in%20her%2020s%2C%20warm%20soft%20lighting%2C%20cream%20background%2C%20friendly%20bright%20expression%2C%20clean%20modern%20style&width=120&height=120&seq=avatar-xb-03&orientation=squarish',
    rating: 5,
    text: '作为一个对品质要求极高的人，性巴克完全满足了我的所有期待。产品不仅外观精美，使用体验也极其出色。每次朋友来家里都会问我哪里买的，已经推荐给很多人了！',
    product: '限量系列',
  },
  {
    name: '陈先生',
    location: '杭州',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20Asian%20man%20in%20his%2040s%2C%20warm%20studio%20lighting%2C%20cream%20background%2C%20friendly%20mature%20expression%2C%20clean%20modern%20style&width=120&height=120&seq=avatar-xb-04&orientation=squarish',
    rating: 4,
    text: '性巴克的产品设计真的很有品味，每个细节都经过精心考量。我特别喜欢他们的品牌文化，感觉不只是在用产品，更像是在体验一种生活方式。售后服务也相当用心。',
    product: '经典系列',
  },
];

export default function TestimonialSection() {
  const [active, setActive] = useState(0);

  return (
    <section className="relative py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-label tracking-[0.15em] text-primary-500 uppercase mb-3">
            用户口碑
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            听听
            <span className="text-primary-500">用户</span>
            怎么说
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            来自全国各地用户的真实评价，性巴克用品质赢得每一份信任。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className="bg-background-100 rounded-2xl p-5 md:p-6 hover:bg-background-50 transition-all duration-300 border border-transparent hover:border-background-200/70"
            >
              <div className="flex items-start gap-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <div>
                      <h4 className="font-label font-semibold text-sm text-foreground-950">
                        {t.name}
                      </h4>
                      <p className="text-xs text-foreground-500">{t.location}</p>
                    </div>
                    <span className="text-xs text-foreground-500 bg-background-200/70 px-2.5 py-1 rounded-full">
                      {t.product}
                    </span>
                  </div>
                  <div className="flex items-center gap-0.5 mb-2.5">
                    {Array.from({ length: 5 }).map((_, j) => (
                      <i
                        key={j}
                        className={`ri-star-fill text-xs ${
                          j < t.rating ? 'text-primary-400' : 'text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    &ldquo;{t.text}&rdquo;
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}